import PropTypes from 'prop-types';
import FormTextField from './FormTextField';

FormTextAreaField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  placeholder: PropTypes.string,
};
export default function FormTextAreaField({
  fieldName,
  fieldAttributes,
  focusedField,
  setFocusedField,
  placeholder = '',
}) {
  return (
    <FormTextField
      fieldName={fieldName}
      fieldAttributes={fieldAttributes}
      focusedField={focusedField}
      setFocusedField={setFocusedField}
      multiline
      placeholder={placeholder}
    />
  );
}
